export const miscArrayEqual = (serverArray: Array<any>, formArray: Array<any>) => {
  for (let i = 0; i < serverArray.length; i++) {
    if (serverArray[i] !== formArray[i]) {
      return false;
    }
  }
  return true;
};

export default class ConcurrencyUtils {
  private diffValues: any[];
  constructor() {
    this.diffValues = [];
  }

  compareValues(serverEntity: any, formEntity: any, path = '') {
    if (Array.isArray(serverEntity)) {
      this.loopArray(serverEntity.slice(), (formEntity ?? []).slice(), path);
    } else if (serverEntity !== null && typeof serverEntity === 'object') {
      this.checkObj(Object.assign({}, serverEntity), Object.assign({}, formEntity), path);
    }
    return this.diffValues;
  }

  loopArray(serverEntity: any, formEntity: any, path: string) {
    let tempFormEntity = formEntity.slice();
    let tempServerEntity = serverEntity.slice();
    if (
      tempFormEntity?.[0]?.id ||
      tempServerEntity?.[0]?.id ||
      tempFormEntity?.[0]?.uuid ||
      tempServerEntity?.[0]?.uuid
    ) {
      //If the first element of either array has an id or uuid, assume it's an entity and compare each element in the array individually.
      tempServerEntity.sort(this.sortByProperty('id'));
      tempFormEntity.sort(this.sortByProperty('id'));

      for (let i = 0; i < tempServerEntity.length; i++) {
        if (typeof tempServerEntity[i] === 'object') {
          let index = this.getIndexOf(formEntity, tempFormEntity[i]);
          if (index !== null) {
            this.compareValues(tempServerEntity[i], tempFormEntity[i], `${path}.${index}`);
          }
        }
      }
    } else {
      //Otherwise if we seem to be looking at an array of strings (For example, statuses), check for any differences and add the whole array to conflicts if any are found.
      tempServerEntity.sort();
      tempFormEntity.sort();
      if (tempFormEntity?.length !== tempServerEntity?.length || !miscArrayEqual(tempServerEntity, tempFormEntity)) {
        this.diffValues.push({
          path: `${path}`.substring(1),
          serverValue: serverEntity,
          formValue: formEntity,
        });
      }
    }
  }

  checkObj(serverEntity: any, formEntity: any, path: string) {
    for (let properties in serverEntity) {
      if (formEntity.hasOwnProperty(properties)) {
        if (serverEntity[properties] !== null && typeof serverEntity[properties] === 'object') {
          this.compareValues(serverEntity[properties], formEntity[properties], `${path}.${properties}`);
        } else {
          if (serverEntity[properties] !== formEntity[properties]) {
            if (
              (formEntity.hasOwnProperty('id') && !serverEntity.hasOwnProperty('id')) ||
              (!formEntity.hasOwnProperty('id') && serverEntity.hasOwnProperty('id'))
            ) {
              this.addToDiffValues(formEntity, serverEntity, path);
              break;
            }

            if (
              formEntity.hasOwnProperty('id') &&
              serverEntity.hasOwnProperty('id') &&
              serverEntity.id !== formEntity.id
            ) {
              this.addToDiffValues(formEntity, serverEntity, path);
              break;
            }

            let tempObj = {
              path: `${path}.${properties}`.substr(1),
              serverValue: serverEntity[properties],
              formValue: formEntity[properties],
            };
            this.diffValues.push(tempObj);
          }
        }
      }
    }
  }

  addToDiffValues(formEntity: any, serverEntity: any, path: string) {
    let tempObj = {
      path: `${path}`.substr(1),
      serverValue: serverEntity,
      formValue: formEntity,
    };
    this.diffValues.push(tempObj);
  }

  sortByProperty(property: string) {
    return function (a: any, b: any) {
      return a[property] < b[property] ? -1 : a[property] > b[property] ? 1 : 0;
    };
  }

  getIndexOf(formEntity: any, tempFormEntity: any) {
    let index = null;
    for (let i = 0; i < formEntity.length; i++) {
      if (tempFormEntity && formEntity && formEntity[i].id === tempFormEntity.id) {
        index = i;
        break;
      }
    }
    return index;
  }
}
